<template>
  <table class="table table-responsive mb-2">
    <thead class="bg-grey">
      <tr>
        <th
          v-for="criterion in criteria"
          :key="criterion"
          style="width: 25%"
        >
          {{ criterionLabel(criterion) }}
        </th>

        <th style="width: 25%">Consideração técnica</th>
        <th style="width: 25%">Atuação recomendada</th>
        <th style="width: 10%">Cor</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(level, levelKey) in model.levels" :key="levelKey">
        <td
          v-for="criterion in criteria"
          :key="criterion"
        >
          <d-form-row class="row-container">
            <span v-if="levelKey === 'level4'" class="mx-1">&gt;</span>

            <!-- MIN -->
            <d-form-input
              v-if="level.min && level.min[criterion] !== undefined"
              class="form-control"
              type="text"
              v-model="level.min[criterion]"
              :placeholder="criterion"
            />

            <span
              v-if="['level1', 'level2', 'level3'].includes(levelKey)"
              class="mx-1"
            >
              a
            </span>

            <!-- MAX -->
            <d-form-input
              v-if="level.max && level.max[criterion] !== undefined"
              class="form-control"
              type="text"
              v-model="level.max[criterion]"
              :placeholder="criterion"
            />
          </d-form-row>
        </td>

        <!-- technical Consideration-->
        <td>
          <d-form-input
            class="form-control text-input"
            type="text"
            v-model="level.technicalConsideration"
            placeholder="Consideração técnica"
          />
        </td>

        <!-- recommended Action -->
        <td>
          <d-form-input
            class="form-control text-input"
            type="text"
            v-model="level.recommendedAction"
            placeholder="Atuação recomendada"
          />
        </td>

        <!-- Cor -->
        <td class="pr-3">
          <d-input
            type="color"
            class="form-control feColor bgColor"
            v-model="level.bgColor"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>


<script>
export default {
  name: 'RiskClassificationTable',
  props: {
    model: {
      type: Object,
      required: true,
    },
    criteria: {
      type: Array,
      required: true,
    },
  },
  methods: {
    criterionLabel(criterion) {
      return criterion === 'VDVR'
        ? 'VDVR (m/s¹·⁷⁵)'
        : 'AREN (m/s²)';
    },
  },
  watch: {
    model: {
      deep: true,
      handler(newValue) {
        this.$emit('update:model', newValue);
      },
    },
  },
};
</script>

<style scoped>
table {
  color: #5a6169;
}

th {
  border-top: none;
  padding-left: 16px;
  color: #424242;
}

td {
  vertical-align: middle;
}

.feColor.bgColor {
  height: 37px;
  min-width: 45px;
}

.row-container {
  display: flex;
  align-items: center;
  gap: 6px;
}

.row-container input {
  width: 65%;
  min-width: 50px;
}
</style>
